const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      link: '.js-statement-item-link',
      modal: '.js-statement-item-full',
      close: '.js-statement-item-full-close',
      column: '.js-statement-column',
      readMore: '.js-statement-content-read-more',
      moreText: '.is-more-text',
      item: '.js-statement-item',
    };

    this.classes = {
      open: 'is-open',
      locked: 'is-locked',
      hasReadMore: 'has-read-more',
    };

    this.modal = null;
    this.breakpoint = window.matchMedia('(max-width: 1024px)');

    $(document).ready(() => {
      if ($(this.selectors.link).length) {
        this.init();
      }
    });
  }

  init() {
    this.modalOpen();
    this.modalClose();
    this.columnReadMore();
  }

  modalOpen() {
    $(this.selectors.link).on('click', e => {
      const button = e.currentTarget;
      $(this.selectors.modal).removeClass(this.classes.open);

      this.modal = $(button)
        .closest(this.selectors.item)
        .find(this.selectors.modal);

      $(this.modal).addClass(this.classes.open);
      $('html').addClass(this.classes.locked);
    });
  }

  modalClose() {
    const closeButton = $(this.selectors.close);

    closeButton.on('click', () => {
      $(this.modal).removeClass(this.classes.open);
      $('html').removeClass(this.classes.locked);
    });
  }

  columnReadMore() {
    const column = $(this.selectors.column);
    if (column.length) {
      const text = column.html();
      const words = text.split(' ');
      const limit = 60;

      let html = '';

      if (words.length > limit) {
        column.parent().addClass(this.classes.hasReadMore);

        $.each(words, (i, word) => {
          if (i === limit) {
            html += `${word}<span class="is-more-dots">...</span> `;
            html += '<span class="is-more-text">';
          } else {
            html += `${word} `;
          }

          if (i === words.length) {
            html += '</span>';
          }
        });
      }

      column.html(html);

      this.toggleReadMore();
    }
  }

  toggleReadMore() {
    const link = $(this.selectors.readMore);

    link.on('click', e => {
      e.preventDefault();

      link.parent().toggleClass(this.classes.open);

      if (link.parent().hasClass(this.classes.open)) {
        link.text(link.attr('data-less'));
      } else {
        link.text(link.attr('data-more'));
      }
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/statement.js